import { Stack } from '@chakra-ui/react';
import { useFAQs, useHelpArticles } from '@frx/frx-react-context';
import {
  FAQ,
  Shareables,
  TipsAndSupport,
  TipsAndSupportOLD,
  TipSectionOLD,
} from './columns';
import { Content, isProd, sanitizeHtml } from '../../utils';
import { useCmsContent, useEventId } from '../../hooks';
import { Wrapper } from '../../components';
// import { FAQOLD } from './columns/FAQ_old';

export const Resources = () => {
  /* The tips and support consists of content fragments
   *  For MVP the order of these fragments is hard coded in the UI
   *  A future iteration will support AEM integration to query the desired order.
   */
  const promoting = useCmsContent({ id: Content.promoting, sanitize: false });
  const team = useCmsContent({ id: Content.team, sanitize: false });
  const donations = useCmsContent({ id: Content.donations, sanitize: false });
  const eventId = useEventId();

  const pushSection = (sections_: TipSectionOLD[], section: TipSectionOLD) => {
    const articles = section.articles.map((article: any) => ({
      title: article.title,
      content: sanitizeHtml(article.content),
    }));
    sections_.push({ title: section.title, articles });
  };

  const sections: TipSectionOLD[] = [];
  pushSection(sections, {
    title: 'Promoting your fundraiser',
    articles: promoting.articles,
  });

  pushSection(sections, {
    title: 'Managing donations',
    articles: donations.articles,
  });

  pushSection(sections, {
    title: 'Managing your fundraising team',
    articles: team.articles,
  });

  const { data: faqs } = useFAQs({ variation: String(eventId) });
  const { data: helpArticlesData } = useHelpArticles({
    variation: String(eventId),
  });

  return (
    <Stack
      direction={['column', 'column', 'column', 'row']}
      spacing={[0, 0, 6]}
    >
      <Wrapper>
        <Shareables />
      </Wrapper>
      <Wrapper>
        {/** TODO: remove isProd when deploying CMS */}
        {!isProd ? (
          <>
            <FAQ faqsData={faqs?.data.faqList.items || []} />
            <TipsAndSupport
              helpArticlesData={
                helpArticlesData?.data.informationalList.items || []
              }
            />
          </>
        ) : (
          <>
            <FAQ faqsData={faqs?.data.faqList.items || []} />
            <TipsAndSupportOLD sections={sections} />
          </>
        )}
        {/*
        
        */}
      </Wrapper>
    </Stack>
  );
};
